import * as React from 'react';

import { ContextProviderProps } from 'types/contextProviderProps';
import { FacilitySelectOption } from 'types/inputProps';

import { ActiveFacilityContext } from 'context/activeFacility';

const ActiveFacilityProvider = (props: ContextProviderProps): React.JSX.Element => {
  const [currentFacility, setCurrentFacility] = React.useState<FacilitySelectOption>({
    label: sessionStorage.getItem('facilityName') ?? '',
    value: sessionStorage.getItem('facilityID') ?? '',
    isCoreMeasures: sessionStorage.getItem('facilityCM') === 'true',
    hasServiceCodes: sessionStorage.getItem('facilitySVC') === 'true',
    pixDataEntry: sessionStorage.getItem('facilityPIX') ?? '',
    isUHS: sessionStorage.getItem('facilityUHS') === 'true',
    isOutcomes: sessionStorage.getItem('facilityOutcomes') === 'true',
  });

  React.useEffect(() => {
    sessionStorage.setItem('facilityName', currentFacility.label);
    sessionStorage.setItem('facilityID', currentFacility.value);
    sessionStorage.setItem('facilityCM', currentFacility.isCoreMeasures ? 'true' : 'false');
    sessionStorage.setItem('facilitySVC', currentFacility.hasServiceCodes ? 'true' : 'false');
    sessionStorage.setItem('facilityPIX', currentFacility?.pixDataEntry ?? '');
    sessionStorage.setItem('facilityUHS', currentFacility.isUHS ? 'true' : 'false');
    sessionStorage.setItem('facilityOutcomes', currentFacility.isOutcomes ? 'true' : 'false');
  }, [currentFacility]);

  return (
    <ActiveFacilityContext.Provider
      value={{
        facility: currentFacility,
        SwitchFacility: (option: FacilitySelectOption): void => {
          setCurrentFacility(option);
        },
      }}
    >
      {props.children}
    </ActiveFacilityContext.Provider>
  );
};

export default ActiveFacilityProvider;
